import { render, staticRenderFns } from "./bookingWorkspace.vue?vue&type=template&id=5722c0a3&scoped=true&"
import script from "./bookingWorkspace.vue?vue&type=script&lang=js&"
export * from "./bookingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./bookingWorkspace.vue?vue&type=style&index=0&id=5722c0a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722c0a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5722c0a3')) {
      api.createRecord('5722c0a3', component.options)
    } else {
      api.reload('5722c0a3', component.options)
    }
    module.hot.accept("./bookingWorkspace.vue?vue&type=template&id=5722c0a3&scoped=true&", function () {
      api.rerender('5722c0a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/bookingWorkspace.vue"
export default component.exports